import ApplicationController from '../../application_controller.js';
import { Janus } from 'janus-gateway';
import { SCREENSHARE_SUFFIX } from './screenshare_connection.js';

// Video Connection Functions

export default class VideoConnectionController extends ApplicationController {

    getLocalVideoStream(videoDeviceId) {
        let self = this;
        return new Promise((resolve, reject) => {
            // Limit to streams associated with the selected camera ID
            self.videoConstraints = {
                deviceId: { ideal: videoDeviceId },
                aspectRatio: {ideal: 16/9},
                width: { ideal: 1280 },
                height: { ideal: 720 }
            };
    
            window.videoConstraints = self.videoConstraints;
    
            var constraints = { 
                video: self.videoConstraints,
                audio: false 
            };
    
            // Fetch and log the selected camera's description
            navigator.mediaDevices.enumerateDevices()
                .then((devices) => {
                    const selectedCam = devices.find(device => device.deviceId === videoDeviceId);
                    return navigator.mediaDevices.getUserMedia(constraints);
                })
                .then(function(originalStream) {     
                    // Disable audio
                    const audioTracks = originalStream.getAudioTracks();
                    audioTracks.forEach(track => {
                        track.enabled = false;
                    });
    
                    // Get video track settings
                    const videoTrack = originalStream.getVideoTracks()[0];
                    const settings = videoTrack.getSettings();
                    const resolution = { width: settings.width, height: settings.height };
                    const aspectRatio = settings.width / settings.height;
    
                    // if it's already 16:9 just return the unmodified stream
                    if (aspectRatio === 16 / 9) {
                        resolve(originalStream);
                    } else {
                        // Process the video stream
                        resolve(originalStream);
                        //resolve(self.formatLocalVideo(originalStream));
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    attachVideoRoom() {

        let self = this;
        let janus = window.janus
        return new Promise((resolve, reject) => {
        janus.attach(
            {
                plugin: "janus.plugin.videoroom",
                success: (pluginHandle) => {
                    self.pluginHandle = pluginHandle;
                    resolve(pluginHandle);
                },
                error: (error) => {
                    reject(error);
                },
                iceState: function(state) {
                    Janus.log("Upstream Video ICE state changed to " + state);
                    if (state == "failed") {
                        location.reload();
                    }
                },
                mediaState: function(medium, on, mid) {
                    Janus.log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium + " (mid=" + mid + ")");
                    if (on && self.resolveVideoAnswered) {
                        // resolve the promise from startMyVideo if we start sending video
                        self.resolveVideoAnswered();
                    }

                },
                webrtcState: function(on) {
                    Janus.log("Janus says our Upstream Video PeerConnection is " + (on ? "up" : "down") + " now");
                    if (!on && self.resolveStopMyVideo) {
                        // resolve the promise from stopMyVideo if we stop sending video
                        self.resolveStopMyVideo();
                    }
                },
                slowLink: function(uplink, lost, mid) {
                       
                },
                onmessage: function(msg, jsep) {
                    self.handleVideoRoomMessage(self.pluginHandle, msg, jsep);
                },
                onlocaltrack: function(track, on) {
                                
                    
                },
                onremotetrack: function(track, mid, on) {
                    // The publisher stream is sendonly, we don't expect anything here
                },
                oncleanup: function() {
                    Janus.log(" ::: Got a cleanup notification: we are unpublished now :::");
 
                }
            });
        });
    }

    // Join video room as a publisher
    joinVideoRoom(pluginHandle, callObject) {
        let self = this;
        return new Promise((resolve, reject) => {
            let register = {
                request: "joinandconfigure",
                room: callObject.scheduled_session_id,
                ptype: "publisher",
                display: callObject.contactId
            };
            pluginHandle.send({
                message: register,
                success: (response) => {
                    self.resolveJoinVideoRoom = resolve;
                    self.rejectJoinVideoRoom = reject;
                },
                error: (error) => {
                    reject(error);
                }
            });
        });
    }

    startMyVideo(pluginHandle, callObject) {
        let self = this;
        let localStream = callObject.localVideoStream;
        console.debug("Joining with", callObject.localVideoStream);
        let scheduledSessionId = callObject.scheduled_session_id;
    
        self.callObject = callObject;
    
        // Reset state variables
        self.resolveVideoAnswered = null;
        self.rejectVideoAnswered = null;
        self.startVideoPromise = null;
    
        self.startVideoPromise = new Promise((resolve, reject) => {
            this.calculateEncoding(pluginHandle, scheduledSessionId)
                .then(videoEncodings => {
                    const videoTrack = localStream.getVideoTracks()[0];
                    if (!videoTrack) {
                        throw new Error("No video track found in the local stream");
                    }
    
                    pluginHandle.createOffer(
                        {
                            
                            simulcast: true,
                            tracks: [{type: 'video', simulcast: true, capture: videoTrack, sendEncodings: videoEncodings}],
                            success: function(jsep) {
                                Janus.debug("Got publisher SDP!", jsep);
                                var publish = { request: "configure", audio: false, video: true };
                                
                                pluginHandle.send({ message: publish, jsep: jsep });
    
                                window.localVideoStream = localStream;
                                
                                // Create a timeout promise that rejects after 10 seconds if we've not joined yet
                                const timeoutPromise = new Promise((_, reject) => {
                                    setTimeout(() => {
                                        reject(new Error("Video call not accepted"));
                                    }, 10000); 
                                });
    
                                self.rejectVideoAnswered = reject;
                                // Race the timeout promise with the acceptance promise
                                Promise.race([
                                    new Promise((resolve) => {
                                        self.resolveVideoAnswered = resolve;
                                    }),
                                    timeoutPromise
                                ])
                                .then(resolve)
                                .catch(reject);
                            },
                            error: function(error) {
                                Janus.error("WebRTC error:", error);
                                reject(error);
                            }
                        });
                })
                .catch(error => {
                    reject(error);
                });
        });
        return this.startVideoPromise;
    }

    // Calculate the video bitrate based on the number of participants in the room
    calculateEncoding(pluginHandle, scheduledSessionId) {
        return new Promise((resolve, reject) => {
            const encodings = {
            TWO_PARTIES: {rid: "m", active: true, maxBitrate: 1200000, maxFramerate: 24, scaleResolutionDownBy: 1},
            FOUR_PARTIES: {rid: "m", active: true, maxBitrate: 350000, maxFramerate: 24, scaleResolutionDownBy: 2},
            SIX_PARTIES: {rid: "m", active: true, maxBitrate: 200000, maxFramerate: 15, scaleResolutionDownBy: 3},
            NINE_PARTIES: {rid: "m", active: true, maxBitrate: 100000, maxFramerate: 10, scaleResolutionDownBy: 4},
            LOW_BANDWIDTH: {rid: "l", active: true, maxBitrate: 50000, maxFramerate: 10, scaleResolutionDownBy: 5}
            };
        
            let my_encodings = [];
            let participants = 0;
            let publishers = 0;
        
            // Get number of video room participants
            const body = {request: "listparticipants", room: scheduledSessionId};
            pluginHandle.send({
            message: body,
            success: function(result) {
                participants = result.participants || [];
                // Screen shares don't count: they shouldn't push everyone's camera
                // into a lower bitrate tier
                publishers = participants.filter(participant => participant.publisher === true && !String(participant.display).endsWith(SCREENSHARE_SUFFIX)).length;
        
                // Set encoding parameters based on number of participants
                let primary_encoding = null;
                if (publishers <= 2) {
                primary_encoding = encodings.TWO_PARTIES;
                } else if (publishers <= 4) {
                primary_encoding = encodings.FOUR_PARTIES;
                } else if (publishers <= 6) {
                primary_encoding = encodings.SIX_PARTIES;
                } else if (publishers > 6) {
                primary_encoding = encodings.NINE_PARTIES;
                }
        
                // Use simulcast if upload bandwidth is good enough
                my_encodings = [primary_encoding, encodings.LOW_BANDWIDTH];
        
                // Resolve the promise with my_encodings
                resolve(my_encodings);
            },
            error: function(error) {
                // Reject the promise with the error message
                reject(error);
            }
            });
        });
        }

        stopMyVideo(pluginHandle) {
            let self = this;
            return new Promise((resolve, reject) => {
                var unpublish = { request: "unpublish" };
                pluginHandle.send({
                    message: unpublish,
                    success: () => {
                        self.resolveStopMyVideo  = resolve;
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
            });
        }


    leaveVideoRoom(pluginHandle, callObject) {
        let self = this;
        return new Promise((resolve, reject) => {
            window.remoteStreams = {};
            pluginHandle.send({
                message: { request: "leave", room: callObject.scheduled_session_id },
                success: () => {
                    pluginHandle.detach();
                    resolve("Successfully left the video room");
                },
                error: (error) => {
                    reject(error);
                }
            });
        });
    }

    disableSimulcast(pluginHandle) {
        pluginHandle.send({
            message: { request: "configure", video: { substream: 1, temporal: 1 } },
            success: () => {
                console.warn("Simulcast disabled");
            },
            error: (error) => {
                console.error("Error disabling simulcast:", error);
            }
        });
    }

    handleVideoRoomMessage(pluginHandle, msg, jsep) {
        let self = this;
        var event = msg.videoroom;

        //console.warn(msg);
        if (msg.publishers || msg.unpublished){
            //self.updateEncoding();
        }

        if(event) {
            if(event === "joined") {
                // Publisher/manager created, negotiate WebRTC and attach to existing feeds, if any
                self.resolveJoinVideoRoom
                self.myid = msg["id"];
                self.mypvtid = msg["private_id"];
                Janus.log("Successfully joined room " + msg["room"] + " with ID " + self.myid);
                sessionStorage.setItem('pvtid', self.mypvtid);
   
                
            
            } else if (msg.joining) {
                // A new publisher is joining, this is triggered when a new participant joins the room and publishes their video
                // So we add the stream to th
                let joining = msg.joining;
                self.addRemoteStream(joining);

            } else if (msg.publishers) {
                // Existing publishers in the room
                let publishers = msg.publishers;
                publishers.forEach(publisher => self.addRemoteStream(publisher));

            } else if (msg.leaving || msg.unpublished) {
                // A publisher has left or unpublished

            } else if(event === "destroyed") {
                // The room has been destroyed
                Janus.warn("The room has been destroyed!");

            } else  {
                //console.warn("2:", msg);

            }
            if(jsep) {
                Janus.debug("Handling SDP as well...", jsep);
                pluginHandle.handleRemoteJsep({ jsep: jsep });
                var video = msg["video_codec"];
                var mystream = window.localVideoStream;
                if(mystream && mystream.getVideoTracks() && mystream.getVideoTracks().length > 0 && !video) {
                    console.warn("Our video stream has been rejected, viewers won't see us");
                    // Guarded: rejectVideoAnswered is null between startMyVideo's
                    // reset and createOffer succeeding. Calling it unguarded throws
                    // a TypeError inside the janus onmessage callback, outside the
                    // promise chain, and the publish times out anyway.
                    if (self.rejectVideoAnswered) {
                        self.rejectVideoAnswered(new Error("Video stream rejected"));
                    }
                } else {
                    
                }
            }       
        }
    }

    //connect any streams that are already in the room
    connectRemoteStreams(pluginHandle, callObject) {
        let self = this;
        let publishers = [];
        let body = {
            request: "listparticipants",
            room: callObject.scheduled_session_id
        };
        pluginHandle.send({
            message: body,
            success: function(result) {
                publishers = result.participants.filter(participant => participant.publisher === true);
                
                // Check if all publishers' streams are in window.remoteStreams
                publishers.forEach(publisher => {
                    let remoteContactId = publisher.display;
                    if (!window.remoteStreams || !window.remoteStreams[remoteContactId]) {
                        self.addRemoteStream(publisher,callObject);

                    }
                });
                
                // Check if any streams in window.remoteStreams are no longer in the publishers list
                if (window.remoteStreams) {
                    Object.keys(window.remoteStreams).forEach(remoteContactId => {
                        let publisherExists = publishers.some(publisher => publisher.display === remoteContactId);
                        if (!publisherExists) {
                            delete window.remoteStreams[remoteContactId];
                        }
                    });
                }
            }
        });
    }

    addRemoteStream(publisher, callObject=null) {
 
        callObject = callObject || this.callObject
        let self = this
        let janus = window.janus
        let remoteJanusId = publisher.id;
        let remoteContactId = publisher.display;
        let remoteStream = null;


        // Check if its our stream and dont add it, if it is. That includes our own
        // screen share: the sharer renders it from the local capture instead.
        if (remoteContactId == callObject.contactId || remoteContactId == `${callObject.contactId}${SCREENSHARE_SUFFIX}`) {
            return;
        }
        
        janus.attach(
            {
                plugin: "janus.plugin.videoroom",
                //opaqueId: opaqueId,
                success: function(pluginHandle) {
                    remoteStream = pluginHandle;
                    let subscribe = {
                        request: "join",
                        room: callObject.scheduled_session_id,
                        ptype: "subscriber",
                        feed: remoteJanusId,
                        private_id: parseInt(self.mypvtid),
                        substream: 1,
                    };
                    remoteStream.send({ message: subscribe });

                    // Create a unique listener function for this remote stream
                    const uniqueListener = (event) => {
                        if (remoteStream && remoteStream.webrtcStuff && remoteStream.webrtcStuff.pc) {
                            console.warn(`Received switchToLowRes event for ID`, remoteJanusId);
                            self.switchToLowResFeed(remoteStream, callObject);
                        } else {
                            console.warn(`Received switchToLowRes event, but remoteStream is not ready for ID`, remoteJanusId);
                        }
                    };

                    // Add the event listener with the unique function
                    document.addEventListener('switchToLowRes', uniqueListener);

                    // Store the listener function on the remoteStream object for later removal
                    remoteStream.uniqueListener = uniqueListener;
                },
                error: function(error) {
                    Janus.error("  -- Error attaching plugin for contact", remoteContactId, error);
                },
                iceState: function(state) {
                    Janus.log("Downstream Video PeerConnection for " + remoteContactId + " ICE state changed to " + state);
                },
                mediaState: function(medium, on, mid) {
                    Janus.log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium + " (mid=" + mid + ")");
                },
                webrtcState: function(on) {
                    Janus.log("Downstream Video PeerConnection for " + remoteContactId + " is " + (on ? "up" : "down") + " now");  
                },
                slowLink: function(uplink, lost, mid) {
                    Janus.warn("Janus reports problems " + (uplink ? "sending" : "receiving") + " packets on mid " + mid + " (" + lost + " lost packets)");
                },
                onmessage: function(msg, jsep) {
                    //console.warn("Received remotestream message:", msg);

                    if(msg.videoroom && msg.videoroom === "attached") {
                        Janus.log("Remote stream attached for contact ", remoteContactId);
                    }

                    if(msg.videoroom && msg.leaving === "joined") {
                        Janus.log("Remote stream joined for contact ", remoteContactId);
                    }

                    if(msg.videoroom && msg.videoroom === "updated") {
                        let streams = msg.streams
                        let active_stream = streams.find(stream => stream.active)
                        if (!active_stream) {
                            //This means the remote stream is no longer active, so we should detach
                            console.warn("Received updated for contact", remoteContactId, "but no active stream")
                            remoteStream.detach();
                        }
                    }

                    if(msg.error) {
                        Janus.error("Remote stream error", remoteContactId, msg.error);
                    }

                    //if we have a jsep, we have a new offer respond to it
                    if(jsep) {

                        Janus.debug("Handling SDP as well...", jsep);
                        remoteStream.createAnswer(
                            {
                                jsep: jsep,
                                tracks: [{type: 'video', recv: true}],	// We want recvonly audio/video
                                success: function(jsep) {
                                    Janus.debug("Got SDP!", jsep);
                                    var body = { request: "start", room: callObject.scheduled_session_id };
                                    remoteStream.send({ message: body, jsep: jsep });
                                },
                                error: function(error) {
                                
                                    Janus.error("WebRTC error:", error);
                                }
                            });
                    }  
                },

                onremotetrack: function(track, mid, on) {
                    
                    if (on) {
                        var remoteVideoStream = new MediaStream([track]);
   
                        if (!window.remoteStreams) {
                            window.remoteStreams = {};
                        }
                        if (window.remoteStreams[remoteContactId] !== remoteVideoStream) {
                            window.remoteStreams[remoteContactId] = remoteVideoStream;
                            
                            // Fire an event to indicate that a new remote stream has been added
                            const event = new CustomEvent('remoteStreamAdded', { detail: { remoteContactId: remoteContactId } });
                            document.dispatchEvent(event);
                        }

                    } else {
                        console.warn("Remote track stopped for contact", remoteContactId, mid);
                        console.warn("Remote streams:", window.remoteStreams);
                        // Handle the case when the track is removed
                        if (window.remoteStreams && window.remoteStreams[remoteContactId]) {
                            delete window.remoteStreams[remoteContactId];
                        }
                    }
                },
                oncleanup: function() {
                    console.warn("Received oncleanup for remote stream", remoteStream)
                    
                    // Remove the stream from window.remoteStreams when cleaned up
                    if (window.remoteStreams && window.remoteStreams[remoteContactId]) {
                        delete window.remoteStreams[remoteContactId];
                    }
                    
                    // Remove the unique event listener when cleaning up
                    if (remoteStream && remoteStream.uniqueListener) {
                        document.removeEventListener('switchToLowRes', remoteStream.uniqueListener);
                    }

                    Janus.log("Downstream Video PeerConnection for " + remoteContactId + " is cleaned up now");
                }
            });

    }

    switchToLowResFeed(pluginHandle, callObject) {
        var subscribe = {
            request: "configure",
            substream: 0,
        };
        
        console.warn("Switching to low res feed for " + callObject.contactId);
        pluginHandle.send({
            message: subscribe,
            success: function() {
                console.warn("Successfully switched stream");
            },
            error: function(error) {
                console.error("Error switching stream:", error);
            }
        });
    }
}